import { Controller } from "@hotwired/stimulus"

// Switches the free texts of one card or block of the report form between the original and its
// machine translation (CustomReportTranslationsHelper#report_translatable). Only visibility
// changes: the inputs stay in the form, so a save never loses what was written, and the
// translation is read-only. Each card and block switches on its own; the last choice is stored
// on the account (ReportReadingModesController) and opens every report from then on.
//
// A block nested in a card has its own controller, and Stimulus scopes targets to the closest
// one, so switching the card leaves its blocks alone.
export default class extends Controller {
  static targets = ["original", "translated", "switch", "button"]
  static values = { mode: String, url: String }

  // Rows arrive after connect too (a prefill re-renders its turbo-frame), so every new target
  // takes the current mode.
  translatedTargetConnected() {
    this.render()
  }

  switchTargetConnected() {
    this.render()
  }

  modeValueChanged() {
    this.render()
  }

  switch(event) {
    const mode = event.params.mode
    if (mode === this.modeValue) return

    this.modeValue = mode
    this.persist(mode)
  }

  render() {
    const translated = this.modeValue === "translated"
    this.originalTargets.forEach((element) => (element.hidden = translated))
    this.translatedTargets.forEach((element) => (element.hidden = !translated))
    this.switchTargets.forEach((element) => (element.hidden = !this.hasTranslatedTarget))
    this.buttonTargets.forEach((button) =>
      button.setAttribute(
        "aria-pressed",
        String(button.dataset.reportReadingModeParam === this.modeValue),
      ),
    )
  }

  // Fire-and-forget: on failure the next report simply opens in the previous mode.
  persist(mode) {
    if (!this.hasUrlValue) return

    const token = document.head.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
    fetch(this.urlValue, {
      method: "PATCH",
      credentials: "same-origin",
      headers: {
        "X-CSRF-Token": token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ mode }),
    }).catch(() => {})
  }
}
